var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-dashboard"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.group)+" Dashboard")]),_c('div',{staticClass:"md-layout md-gutter chart-wrapper"},_vm._l((_vm.graphs),function(graph,key){return _c(key,{key:key,tag:"component"})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }